<template>
    <span>
        <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
                <v-btn @click="open" color="primary" icon v-bind="attrs" v-on="on">
                    <AppIcon :src="require('@/assets/column_selector.svg')" :size="32" :colorMap="{ '663399': 'primary', '66359B': 'primary' }" />
                </v-btn>
            </template>
            <span>Selector de columnas</span>
        </v-tooltip>

        <app-confirm-modal
            v-model="showRestoreDialog"
            text-msg="A continuación va a resetear la configuración de columnas para esta empresa"
            text-question="¿Estás seguro que quieres continuar?"
            @confirm="restoreConfiguration"
            @cancel="showRestoreDialog = false"
        ></app-confirm-modal>

        <draggable-show-hide-dialog
            v-model="dialog"
            :title="title"
            :show_columns="showHeaders"
            :hide_columns="hiddenHeaders"
            :key="dialog"
            @update="updateColumns"
            @cancel="dialog=false"
        >
            <template v-slot:top_actions>
                <slot name="actions"></slot>
            </template>
            <template v-slot:header-actions="{ confirm }">
                <v-row class="ma-0 pa-0 justify-space-between">
                    <v-col cols="12" sm="6" class="d-flex ma-0 pa-0 justify-start">
                        <v-btn large outlined color="primary" @click="dialog=false">
                            Cancelar
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" class="d-flex ma-0 pa-0 justify-end" style="gap: 12px;">
                        <v-btn
                            v-if="hasCustomConfig && companyId"
                            large
                            outlined
                            color="primary"
                            @click="showRestoreDialog = true"
                        >
                            Restaurar
                        </v-btn>
                        <v-btn large color="primary" @click="confirm">
                            Confirmar
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </draggable-show-hide-dialog>
    </span>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from 'vuex-map-fields';
import DraggableShowHideDialog from './DraggableShowHideDialog.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue';
import { client, sync_command_dispatcher } from "@/api/client";
import { RestoreConfigurationCompanyCommand } from "@/modules/company/application/RestoreConfigurationCompanyCommand";

export default {
    name: 'ShowHideColumnsDialog',
    props: {
        title: {
            type: String,
            default: 'Selector de columnas'
        },
        read_only:{
            type:Boolean,
            default:false,
        },
        showHideDialog:{
            type: Boolean,
            required: false,
            default: null,
        },
        companyId: {
            type: Number,
            required: false,
            default: null,
        },
        settingCode: {
            type: String,
            required: false,
            default: 'document_list_headers',
        },
    },
    data() {
        return {
            dialog: this.showHideDialog || false,
            show: [],
            hide: [],
            hasCustomConfig: false,
            showRestoreDialog: false,
        }
    },
    components: {
        DraggableShowHideDialog,
        AppConfirmModal,
    },
    computed: {
        ...mapFields('documents', ['documentListHeaders', 'documentListHiddenHeaders','documentListHeadersReadOnly','documentListHiddenHeadersReadOnly']),
        showHeaders(){
            if(this.read_only){
                return this.documentListHeadersReadOnly
            }
            else{ 
                return this.documentListHeaders
            }
        },
        hiddenHeaders(){
            if(this.read_only){
                return this.documentListHiddenHeadersReadOnly
            }
            else{ 
                return this.documentListHiddenHeaders
            }
        },

    },
    methods:{
        ...mapActions({
            getHeader: "documents/getHeader",
            setHeader: "documents/setHeader",
            setHeaderReadOnly: "documents/setHeaderReadOnly",
        }),
        open() {
            this.dialog = !this.dialog;
            if (this.dialog && this.companyId) {
                this.checkHasCustomConfig();
            }
        },
        updateColumns(data) {
            if(!this.read_only){
                this.documentListHeaders = data['show']
                this.documentListHiddenHeaders = data['hide']
                this.setHeader().then(() => {
                    this.dialog = false;
                    this.hasCustomConfig = true;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }
            else{
                this.documentListHeadersReadOnly = data['show']
                this.documentListHiddenHeadersReadOnly = data['hide']
                this.setHeaderReadOnly().then(() => {
                    this.dialog = false;
                    this.hasCustomConfig = true;
                }).catch(err => {
                    console.error(err);
                    this.dialog = false;
                });
            }

        },
        async checkHasCustomConfig() {
            if (!this.companyId) return;
            try {
                const resp = await client.get(`settings/has_custom_setting/${this.settingCode}/${this.companyId}/`);
                this.hasCustomConfig = resp.data.has_custom_config;
            } catch (e) {
                console.error(e);
                this.hasCustomConfig = false;
            }
        },
        async restoreConfiguration() {
            this.showRestoreDialog = false;
            this.dialog = false;
            try {
                await new RestoreConfigurationCompanyCommand(sync_command_dispatcher, this).run(this.companyId, this.settingCode);
                await this.getHeader();
                this.hasCustomConfig = false;
                this.$emit('restored', { success: true, message: 'Configuración restaurada correctamente' });
            } catch (e) {
                console.error(e);
                this.$emit('restored', { success: false, message: 'Error al restaurar la configuración' });
            }
        },
    },
    mounted(){
        this.getHeader()
        if (this.companyId) {
            this.checkHasCustomConfig();
        }
    },
}
</script>

<style lang="scss" scoped>
    .primary-bckground {
        background-color: var(--v-primary-base);
    }
    .primary-border {
        border-color: var(--v-primary-base) !important;
    }
    .draggable-item {
        border-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .text-color {
        color: var(--v-primary-base);
    }
</style>

<style>
.v-input__slot {
  width: 70% !important;
}
</style>